import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationService } from '@app/shared/application/application.service';
import { SplService } from './spl.service';
import { AppComponentBase } from '@shared/common/app-component-base';

@Injectable()
export class SplGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private splService: SplService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.splService.getSpl(this.applicationService.caseId).pipe(map(() => true));
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.splService.closeSpl();
        return true;
    }
}
